import { usePromptInjection } from "src/hooks/useToolActions";
import { useStore } from "src/stores";

/** Opens a new agent thread with the composer ready for the user to describe the change. */
export const useOpenChangeManagementAgent = () => {
  const { uiStore } = useStore();
  const { injectPrompt } = usePromptInjection();
  return () => {
    uiStore.setIsRightPanelOpen(true);
    injectPrompt({
      prompt: "Use the Change Management subagent to help with: ",
      preview: "New change management run",
      source: "change-management-new-run",
      replaceInput: true,
      submit: false,
      newThread: true,
    });
  };
};
